<template>
  <div class="roomControl" :class="{noData: !roomKey || !info}">
    <div v-if="!dataLoad" class="noRoomControl notranslate">
      <p>{{locale.data_loading}}</p>
    </div>
    <div v-else-if="!roomKey || !info" class="noRoomControl notranslate">
      <img src="@/assets/img/question.png" alt="">
      <p>{{locale.roomcontrol_nodata}}</p>
    </div>
    <div v-else>
      <h1 class="boxTitle mb15 toCapitalize notranslate">
        {{locale.roomcontrol}}
        <button type="button" class="btnRefresh" @click="refresh"></button>
      </h1>
      <p v-if="wsStatus === 'close'" class="sysMessage notranslate">
        {{locale.message_roomcontrol_close}}
        <button type="button" class="btn btnWhite sizeXs btnRound" @click="wsConnect">{{locale.reconnect}}</button>
      </p>
      <p v-if="wsStatus === 'fail'" class="sysMessage notranslate">
        {{locale.message_connection}}
      </p>
      <div class="groupWrap">
        <ControlGroup
          v-for="group in list"
          :key="group.id"
          :lang="lang"
          :locale="locale"
          :info="info"
          :group="group"
          @setRcu="setRcu" />
      </div>
    </div>
    <div v-if="statusMessage" class="msgToast notranslate" :class="{success: success}">
      <p v-html="statusMessage"></p>
      <button v-if="wsStatus === 'close'" type="button" class="btn btnWhite btnRound mt10" @click="wsConnect">{{locale.reconnect}}</button>
    </div>
  </div>
</template>

<script>
import ControlGroup from '@/components/Control/ControlGroup.vue'

export default {
  name: 'Control',
  props: [
    'lang',
    'locale',
    'roomKey'
  ],
  components: {
    ControlGroup
  },
  computed: {
    authentication () {
      return this.$store.state.authentication
    },
    isPublic () {
      return this.authentication.public
    }
  },
  watch: {
    '$route' (to, from, next) {
      if (to.params.id !== from.params.id) {
        this.init()
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
    this.wsConnect()
  },
  destroyed () {
    this.$store.commit('loading', false)
    if (this.socket) {
      this.socket.close()
      this.setStatusMessage('close')
    }
  },
  data () {
    return {
      wsStatus: 'ready',
      dataLoad: false,
      wsMessage: [],
      info: null,
      list: [],
      status: null,
      cnt: 0,
      statusMessage: null,
      current: '',
      success: false
    }
  },
  methods: {
    track (title) {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: title
      })
    },
    wsConnect () {
      if (this.socket === undefined || this.socket.readyState === 3) {
        this.socket = new WebSocket(process.env.VUE_APP_WS_RCU)
        this.socket.onopen = (e) => {
          // console.log('open')
          this.onOpen(e)
          this.wsStatus = 'open'
        }
        this.socket.onclose = (e) => {
          // console.log('close')
          this.onClose(e)
          this.wsStatus = 'close'
        }
        this.socket.onmessage = (e) => {
          // console.log('message')
          this.onMessage(e)
          this.wsStatus = 'message'
        }
        this.socket.onerror = (e) => {
          // console.log('error')
          this.onError(e)
          this.wsStatus = 'error'
        }
      }
    },
    onOpen (e) {
      const data = {
        action: 'sendmessage',
        data: {
          cmd: 'listen-rcu-update',
          siteid: this.authentication.site,
          spaceid: this.authentication.space,
          ota: this.authentication.k
        }
      }
      this.socket.send(JSON.stringify(data))
    },
    onMessage (e) {
      const res = JSON.parse(e.data)
      this.status = res.data
      if (this.status) {
        this.setItemStatus(res.data)
      }
      this.$store.commit('loading', false)
    },
    onClose (e) {
      this.socket.close()
      this.setStatusMessage('close')
      this.$store.commit('loading', false)
      if (this.isPublic) {
        setTimeout(() => {
          this.refresh()
        }, 3000)
      }
    },
    onError (e) {
      this.setStatusMessage('fail')
      this.$store.commit('loading', false)
      if (this.isPublic) {
        setTimeout(() => {
          this.refresh()
        }, 3000)
      }
    },
    refresh () {
      this.loadStatus()
      this.wsConnect()
      this.$store.commit('loading', false)
    },
    init () {
      const spaceid = this.roomKey
      if (spaceid) {
        this.$store.commit('loading', true)
        this.$store.dispatch('control/getControl', spaceid).then((res) => {
          this.dataLoad = true
          if (res) {
            this.info = res.info
            this.list = res.list
            this.cnt = 2
            this.loadStatus()
          } else {
            this.cnt = 2
            alert(this.locale.invalid_key)
          }
          this.$store.commit('loading', false)
        })
      } else {
        this.dataLoad = true
        alert(this.locale.invalid_key)
      }
    },
    setStatusMessage (status) {
      if (status === 'noStatus') {
        // 등록된 제어모듈 정보가 없습니다. 객실제어가 올바르게 작동하지 않을 수 있습니다.
        this.statusMessage = `${this.locale.message_roomcontrol_nostatus}<br>${this.locale.message_roomcontrol_malfunction}`
      } else if (status === 'fail') {
        // 연결상태가 원활하지 않습니다.
        this.statusMessage = this.locale.message_connection
      } else if (status === 'close') {
        // 현재상태를 불러올 수 없습니다.
        this.statusMessage = this.locale.message_roomcontrol_close
      } else if (status === 'doorOk') {
        // 문이 열립니다.
        this.statusMessage = this.locale.message_door_open
      }
      setTimeout(() => {
        this.statusMessage = null
      }, 5000)
    },
    setItemStatus (s) {
      function getStatus (item, status) {
        let result = status[item.index]
        const all = Object.keys(status).filter(x => x.includes(item.type))
        // light all
        if (item.type === 'light') {
          if (item.index === 'all') { // power all
            if (all.filter(x => status[x] === 1).length) {
              result = 1
            } 
          } else if (item.index === 'multi') { // power multi
            if (item.multi.filter(x => item.multiOnoff.includes(x) && status[x] === 1).length) {
              result = 1
            }
          } else {
            result = status[item.index]
          }
        } else if (item.type === 'fcu') {
          if (item.detail.control === 'toggle') {
            if (item.index === 'all') { // power all
              if (all.filter(x => status[x].power === 1).length) {
                result = 1
              }
            } else if (item.index === 'multi') { // power multi
              if (item.multi.filter(x => status[x].power === 1).length) {
                result = 1
              }
            } else {
              result = status[item.index].power
            }
          }
        } else if (item.type === 'curtain') {
          if (item.detail.control === 'toggle') {
            if (item.index === 'all') { // curtain all
              if (all.filter(x => status[x] === 1).length) {
                result = 1
              }
            } else if (item.index === 'multi') { // curtain multi
              if (item.multi.filter(x => status[x] === 1).length) {
                result = 1
              }
            } else {
              result = status[item.index]
            }
          }
        }
        return result
      }
      this.list = this.list.map(group => {
        return {
          ...group,
          list: group.list.map(item => {
            return {
              ...item,
              status: getStatus(item, s)
            }
          })
        }
      })
    },
    setRcu (data) {
      this.current = data.item
      this.cnt = 0
      this.$store.commit('loading', true)
      this.$store.dispatch('control/setRoomControl', data).then((res) => {
        if (!res) {
          this.setStatusMessage('fail')
          this.$store.commit('loading', false)
        } else if (res.data.errorMessage && res.data.errorMessage.includes('deviceagent')) {
          this.setStatusMessage('noStatus')
          this.$store.commit('loading', false)
        }
        setTimeout(() => {
          this.$store.commit('loading', false)
          if (res.data.message && res.data.message.toLowerCase() === 'ok') {
            this.success = true
            if (this.current === 'door') {
              this.setStatusMessage('doorOk')
            }
          }
          this.current = ''
        }, 3000)
      })
    },
    loadStatus () {
      this.$store.dispatch('control/getRoomStatus').then((res) => {
        if (res) {
          this.status = res
          this.setItemStatus(res)
        } else {
          this.setStatusMessage('noStatus')
          this.$store.commit('loading', false)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  padding-top: 60px;
  background-color: $color-white;
  .noRoomControl {
    text-align: center;
    img {
      width: 100px;
      margin-bottom: 20px;
      opacity: 0.2;
    }
  }
}
.msgToast {
  position: fixed;
  top: 50%;
  left: 50%;
  width: calc(100% - 30px);
  max-width: 480px;
  padding: 0.5em 1em;
  text-align: center;
  color: $color-white;
  word-break: break-all;
  border-radius: 4px;
  background-color: rgba($color-red, 0.85);
  transform: translate(-50%, -50%);
  &.success {
    background-color: rgba($color-green, 0.85);
  }
}
.sysMessage {
  margin-top: 5px;
  margin-bottom: 15px;
  margin-left: 15px;
  font-size: 12px;
  color: $color-red;
  &:before {
    content: "i";
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 4px;
    text-align: center;
    font-size: 10px;
    border-radius: 100%;
    border: 1px solid $color-red;
  }
  .btn {
    margin-left: 4px;
  }
}
</style>
